import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { CaretDownIcon as CaretDown, CaretRightIcon as CaretRight, FoldersIcon as Folders, FolderIcon as Folder } from "@phosphor-icons/react";

export function KBSidebar({ activeCategoryId, activeFolderId, onData, reloadKey }) {
  const nav = useNavigate();
  const [cats, setCats] = useState([]);
  const [open, setOpen] = useState({});

  useEffect(() => {
    api.get("/kb/categories").then(({ data }) => {
      setCats(data || []);
      onData && onData(data || []);
    }).catch(() => setCats([]));
  }, [reloadKey]); // eslint-disable-line

  useEffect(() => {
    if (activeCategoryId) setOpen((o) => ({ ...o, [activeCategoryId]: true }));
  }, [activeCategoryId]);

  return (
    <aside className="w-64 shrink-0 border border-border rounded-sm bg-white overflow-hidden" data-testid="kb-sidebar">
      <div className="px-3 py-2.5 border-b border-border bg-secondary/40">
        <p className="text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">Categorie e cartelle</p>
      </div>
      <div className="max-h-[70vh] overflow-y-auto">
        {cats.map((c) => {
          const isOpen = !!open[c.id];
          return (
            <div key={c.id} className="border-b border-border/60">
              <button onClick={() => setOpen((o) => ({ ...o, [c.id]: !o[c.id] }))}
                className={`w-full flex items-center gap-2 px-3 py-2.5 text-left hover:bg-secondary/60 ${activeCategoryId === c.id && !activeFolderId ? "bg-blue-50" : ""}`}
                data-testid={`kb-cat-toggle-${c.id}`}>
                <Folders size={16} className="text-slate-500 shrink-0" weight="fill" />
                <span className="flex-1 text-sm font-semibold text-slate-700 truncate">{c.nome}</span>
                {isOpen ? <CaretDown size={13} className="text-muted-foreground" /> : <CaretRight size={13} className="text-muted-foreground" />}
              </button>
              {isOpen && (
                <div className="pb-1">
                  {c.folders_count === 0 && <p className="px-9 py-1.5 text-xs text-muted-foreground italic">Nessuna cartella</p>}
                  {(c.folders || []).map((f) => (
                    <button key={f.id} onClick={() => nav(`/knowledge-base/folder/${f.id}`)}
                      className={`w-full flex items-center gap-2 pl-9 pr-3 py-1.5 text-left hover:bg-secondary/60 ${activeFolderId === f.id ? "bg-blue-100" : ""}`}
                      data-testid={`kb-folder-link-${f.id}`}>
                      <Folder size={14} className="text-slate-400 shrink-0" />
                      <span className="flex-1 text-sm text-slate-600 truncate">{f.nome}</span>
                      <span className="text-[11px] font-medium text-muted-foreground">{String(f.articoli_count).padStart(2, "0")}</span>
                    </button>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </aside>
  );
}
